import React from "react";
import OverlayLoader from "../common-components/OverlayLoader/OverlayLoader";
import ContainerLoader from "../common-components/ContainerLoader";
import Input from "../common-components/form/input";
import quotes from "../auth/image/quote.svg";
import "./SignIn.scss";
import PropTypes from "prop-types";

const SignInUI = ({
  loading,
  isSubmitting,
  formData,
  errors,
  loginErrMsg,
  onChange,
  onSubmit,
  isButtonDisabled,
  logo,
  poweredByLogo
}) => {
  return (
    <>
      {loading ? (
        <ContainerLoader />
      ) : (
        <div className="loginPage">
          <div className="loginPageContent">
            <OverlayLoader loading={isSubmitting} />

            <div className="logocontent">
              <img src={logo} alt="Logo" />
              {poweredByLogo && (
                <div className="powered-by-section">
                  <p className="powered-by-text">Powered by</p>
                  <img src={poweredByLogo} alt="Exora Logo" className="powered-by-logo" />
                </div>
              )}
            </div>

            <div className="login-card shadow-sm">
              <h3>Welcome Back</h3>
              <p className="text-muted text-center">
                Enter your credentials to access your account
              </p>

              {loginErrMsg && (
                <div className="frmgroup">
                  <div
                    id="erpanel"
                    className="error-message-container"
                    style={{ display: "block" }}
                  >
                    {loginErrMsg}
                  </div>
                </div>
              )}

              <form onSubmit={onSubmit}>
                <div className="mb-3">
                  <label htmlFor="username" className="form-label">
                    Username
                  </label>
                  <Input
                    containerClassName={" "}
                    inputClassName={"form-control"}
                    type={errors.userName ? "Warning" : "text"}
                    error={errors.userName}
                    name="userName"
                    placeholder="Enter your username"
                    value={formData.userName}
                    onChange={onChange}
                    preventSpaces={true}
                  />
                  {errors.userName && (
                    <small className="text-danger">{errors.userName}</small>
                  )}
                </div>

                <div className="mb-3">
                  <label htmlFor="password" className="form-label">
                    Password
                  </label>
                  <Input
                    containerClassName={" "}
                    inputClassName={"form-control"}
                    type="password"
                    name="userPassword"
                    placeholder="Enter your password"
                    value={formData.userPassword}
                    onChange={onChange}
                    error={errors.userPassword}
                    preventSpaces={true}
                  />
                  {errors.userPassword && (
                    <small className="text-danger">{errors.userPassword}</small>
                  )}
                </div>

                <div className="signinbtn">
                  <button
                    type="submit"
                    className="btn btn-primary w-100"
                    disabled={isButtonDisabled}
                  >
                    Sign In
                  </button>
                </div>
              </form>
            </div>

            <div className="quotecontent">
              <img src={quotes} alt="Quote" />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
SignInUI.propTypes = {
  loading: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  formData: PropTypes.bool,
  errors: PropTypes.string,
  loginErrMsg: PropTypes.string,
  isButtonDisabled: PropTypes.bool,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default SignInUI;
